export class ProposalObservation {
    constructor(
        public readonly id: string,
        public readonly body: string,
        public readonly createdAt: number,
    ) {}
        
}